import Header from '../../components/Header';
import HeaderImage from '../../images/halasana__.jpg';

import { classDetails } from '../../data';
import ClassLoc from '../../UI/ClassLoc';
import './class.css';

const Class = () => {
  return (
    <>
      <Header title="Classes Locations" image={HeaderImage}>
        We are back live and in person! We are offering classes in-person and online. Please check the schedule for the location and time of the class you would like to attend.
      </Header>

      <section className="location">
        <div className="container locations__container">
          {classDetails.map(({ id, title, description, path, location }) => (
            <ClassLoc
              key={id}
              title={title}
              description={description}
              path={path}
              address={location} // Pass the location array directly
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default Class;